/**
 * MONDE STORE - Product Page Interactions
 */

class ProductManager {
  constructor() {
    this.container = document.querySelector('[data-product-container]');
    if (!this.container) return;

    this.mainImage = document.querySelector('[data-product-main-image]');
    this.thumbs = document.querySelectorAll('[data-product-thumb]');
    this.swatches = document.querySelectorAll('.swatch-item');
    this.variantInput = document.querySelector('[data-selected-variant-id]');
    this.priceRegular = document.querySelector('[data-product-price]');
    this.stickyBar = document.querySelector('.sticky-atc-bar');

    this.initGallery();
    this.initSwatches();
    this.initStickyATC();
  }

  initGallery() {
    this.thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const fullSrc = thumb.dataset.fullSrc;
        if (this.mainImage && fullSrc) {
          this.mainImage.src = fullSrc;
        }
        this.thumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  initSwatches() {
    this.swatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        const group = swatch.closest('.swatch-group');
        if (!group) return;

        group.querySelectorAll('.swatch-item').forEach(s => s.classList.remove('is-selected'));
        swatch.classList.add('is-selected');

        const valueSpan = group.querySelector('.swatch-selected-value');
        if (valueSpan) {
          valueSpan.innerText = swatch.dataset.value;
        }

        // Trigger variant change event if JSON variants provided
        this.onVariantChange();
      });
    });
  }

  onVariantChange() {
    // If product has complex variant JSON
    const script = document.querySelector('[data-product-variants-json]');
    if (!script) return;

    try {
      const variants = JSON.parse(script.textContent);
      const selectedOptions = [];
      document.querySelectorAll('.swatch-item.is-selected').forEach(s => {
        selectedOptions.push(s.dataset.value);
      });

      const matchedVariant = variants.find(v => {
        return v.options.every((opt, i) => opt === selectedOptions[i]);
      });

      if (matchedVariant) {
        if (this.variantInput) {
          this.variantInput.value = matchedVariant.id;
        }
        if (this.priceRegular) {
          const liras = (matchedVariant.price / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2 });
          this.priceRegular.innerText = `${liras} TL`;
        }
        if (matchedVariant.featured_image && this.mainImage) {
          this.mainImage.src = matchedVariant.featured_image.src;
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  initStickyATC() {
    if (!this.stickyBar) return;
    const mainATC = document.querySelector('[data-main-atc-btn]');
    if (!mainATC) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) {
        this.stickyBar.style.display = 'flex';
      } else {
        this.stickyBar.style.display = 'none';
      }
    }, { threshold: 0 });

    observer.observe(mainATC);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ProductManager();
});
